@if (product().bundleType) {
  <ui-product-bundle-list-card
    [product]="product()"
    [productItem]="shoppingListItem()"
    [showCheckbox]="showCheckbox()"
    [quantityCounterConfig]="quantityCounterData()"
    [quantityCounterControl]="quantityCounterControl"
    [selected]="selected()"
    (selectedChange)="selected.set($event)"
    (removed)="onRemoveShoppingListItem()"
  >
  </ui-product-bundle-list-card>
} @else {
  <ui-product-line-item
    [(selected)]="selected"
    [productItem]="shoppingListItem()"
    [quantityCounterControl]="quantityCounterControl"
    [readonly]="readonly()"
    [showCheckbox]="showCheckbox()"
    (removed)="onRemoveShoppingListItem()"
  ></ui-product-line-item>
}
